import { useState } from "react";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import { homeForRole, useAuth } from "@/context/AuthContext";
import { apiError } from "@/lib/api";
import AuthShell from "@/pages/portal/AuthShell";
import { Field, ErrorText, Panel, btnPrimary, inputCls } from "@/components/portal/ui";

export default function LoginPage() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  if (user) return <Navigate to={location.state?.from || homeForRole(user.role)} replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const u = await login(form.email.trim(), form.password);
      navigate(location.state?.from || homeForRole(u.role), { replace: true });
    } catch (err) {
      setError(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthShell title="Accedi all'area riservata" subtitle="Amministrazione, medici e infermieri: accedi con le tue credenziali.">
      <Panel>
        <form onSubmit={submit} className="flex flex-col gap-4" data-testid="login-form">
          <Field label="Email" htmlFor="login-email">
            <input id="login-email" type="email" required autoComplete="email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} placeholder="nome@esempio.it" data-testid="login-email-input" />
          </Field>
          <Field label="Password" htmlFor="login-password">
            <input id="login-password" type="password" required autoComplete="current-password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} placeholder="••••••••" data-testid="login-password-input" />
          </Field>
          <ErrorText testid="login-error">{error}</ErrorText>
          <button type="submit" disabled={loading} className={`${btnPrimary} w-full !py-3`} data-testid="login-submit-btn">
            {loading ? "Accesso in corso…" : "Accedi"}
          </button>
        </form>
      </Panel>

      <div className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
        <Link to="/area-riservata/registrazione-medico" className="rounded-3xl bg-white p-4 ring-1 ring-[#5B2C91]/8 transition-transform hover:-translate-y-0.5" data-testid="login-register-doctor-link">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#5B2C91]">Sei un medico?</p>
          <p className="mt-1 text-sm text-[#4A4059]">Registrati e imposta i tuoi orari di disponibilità.</p>
        </Link>
        <Link to="/area-riservata/registrazione-infermiere" className="rounded-3xl bg-white p-4 ring-1 ring-[#5B2C91]/8 transition-transform hover:-translate-y-0.5" data-testid="login-register-nurse-link">
          <p className="text-xs font-bold uppercase tracking-[0.14em] text-[#0EA5E9]">Sei un infermiere?</p>
          <p className="mt-1 text-sm text-[#4A4059]">Candidati per la rete territoriale TytoCare.</p>
        </Link>
      </div>
      <p className="mt-6 text-center text-xs text-[#8A809A]">
        <Link to="/" className="font-semibold text-[#5B2C91] hover:underline" data-testid="login-back-to-site">← Torna al sito</Link>
      </p>
    </AuthShell>
  );
}
